module.exports = __webpack_public_path__ + "img/assumpta-logo-text.4fd5a234.png";